import {
  MockMap,
  utils,
} from '@ama-sdk/core';
import {
  todayPlusNdays,
} from '@dapi/sdk/helpers';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  acknowledgeSuccess,
  retrieveOrderSwitchedMockDisruptedMultiBounds,
} from '../../../mock/data/index';

const getAlternativeOffersMockDisruptedMultiBounds = {
  data: [
    {
      type: 'alternative-offers',
      id: '1Ba8KkrOdbU',
      expiryDateTime: new utils.DateTime(todayPlusNdays('09:30', 15)),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 6300,
          flights: [
            {
              id: 'FLT1'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bb8Kkr4H5y',
      expiryDateTime: new utils.DateTime(todayPlusNdays('09:30', 15)),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 10_500,
          flights: [
            {
              id: 'FLT2'
            },
            {
              id: 'FLT3'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bc8Kkrj18R',
      expiryDateTime: new utils.DateTime(todayPlusNdays('09:30', 15)),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 11_100,
          flights: [
            {
              id: 'FLT2'
            },
            {
              id: 'FLT4'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bd8KkrtHDk',
      expiryDateTime: new utils.DateTime(todayPlusNdays('09:30', 15)),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 12_900,
          flights: [
            {
              id: 'FLT5'
            },
            {
              id: 'FLT6'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Be8Kkr5RYu',
      expiryDateTime: new utils.DateTime(todayPlusNdays('09:30', 15)),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2100,
          flights: [
            {
              id: 'FLT7'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bf8Kkrymuy',
      expiryDateTime: new utils.DateTime(todayPlusNdays('09:30', 15)),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2100,
          flights: [
            {
              id: 'FLT8'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bg8Kkr-sYy',
      expiryDateTime: new utils.DateTime(todayPlusNdays('09:30', 15)),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2100,
          flights: [
            {
              id: 'FLT9'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bh8KkrNwAm',
      expiryDateTime: new utils.DateTime(todayPlusNdays('09:30', 15)),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2400,
          flights: [
            {
              id: 'FLT10'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bi8Kkr0P_f',
      expiryDateTime: new utils.DateTime(todayPlusNdays('09:30', 15)),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2100,
          flights: [
            {
              id: 'FLT11'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bj8Kkrx1DP',
      expiryDateTime: new utils.DateTime(todayPlusNdays('09:30', 15)),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 12_000,
          flights: [
            {
              id: 'FLT12'
            },
            {
              id: 'FLT13'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bk8KkrES4p',
      expiryDateTime: new utils.DateTime(todayPlusNdays('09:30', 15)),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2100,
          flights: [
            {
              id: 'FLT14'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bl8KkrMJfy',
      expiryDateTime: new utils.DateTime(todayPlusNdays('09:30', 15)),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2100,
          flights: [
            {
              id: 'FLT15'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bm8KkrJdGa',
      expiryDateTime: new utils.DateTime(todayPlusNdays('09:30', 15)),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2100,
          flights: [
            {
              id: 'FLT16'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bn8KkrWEs',
      expiryDateTime: new utils.DateTime(todayPlusNdays('09:30', 15)),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 10_500,
          flights: [
            {
              id: 'FLT17'
            },
            {
              id: 'FLT18'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bo8KkrVca9',
      expiryDateTime: new utils.DateTime(todayPlusNdays('09:30', 15)),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2100,
          flights: [
            {
              id: 'FLT19'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bp8KkrgpRl',
      expiryDateTime: new utils.DateTime(todayPlusNdays('09:30', 15)),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2100,
          flights: [
            {
              id: 'FLT20'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bq8KkrkNEL',
      expiryDateTime: new utils.DateTime(todayPlusNdays('09:30', 15)),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 2400,
          flights: [
            {
              id: 'FLT21'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Br8KkrFHTz',
      expiryDateTime: new utils.DateTime(todayPlusNdays('09:30', 15)),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 6300,
          flights: [
            {
              id: 'FLT22'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bs8KkrLgGF',
      expiryDateTime: new utils.DateTime(todayPlusNdays('09:30', 15)),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 10_500,
          flights: [
            {
              id: 'FLT23'
            },
            {
              id: 'FLT24'
            }
          ]
        }
      }
    },
    {
      type: 'alternative-offers',
      id: '1Bt8KkrC0ql',
      expiryDateTime: new utils.DateTime(todayPlusNdays('09:30', 15)),
      air: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 11_100,
          flights: [
            {
              id: 'FLT23'
            },
            {
              id: 'FLT25'
            }
          ]
        }
      }
    }
  ],
  dictionaries: {
    airline: {
      AY: 'FINNAIR',
      SK: 'SCANDINAVIAN AIRLINES',
      W2: 'FLEXFLIGHT'
    },
    location: {
      ARN: {
        type: 'airport',
        airportName: 'ARLANDA',
        cityCode: 'STO',
        countryCode: 'SE'
      },
      HEL: {
        type: 'airport',
        airportName: 'HELSINKI VANTAA',
        cityCode: 'HEL',
        cityName: 'HELSINKI',
        countryCode: 'FI'
      },
      MHQ: {
        type: 'airport',
        airportName: 'MARIEHAMN',
        cityCode: 'MHQ',
        cityName: 'MARIEHAMN',
        countryCode: 'FI'
      },
      TKU: {
        type: 'airport',
        airportName: 'TURKU',
        cityCode: 'TKU',
        cityName: 'TURKU',
        countryCode: 'FI'
      },
      STO: {
        type: 'city',
        cityCode: 'STO',
        cityName: 'STOCKHOLM',
        countryCode: 'SE'
      }
    },
    flight: {
      FLT3: {
        departure: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime(todayPlusNdays('17:10', 0)),
          terminal: '5'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('19:05', 0)),
          terminal: '1'
        },
        operatingAirlineCode: 'SK',
        marketingAirlineCode: 'SK',
        marketingFlightNumber: '4236',
        duration: 3300,
        aircraftCode: 'AT7'
      },
      FLT8: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('16:15', 0)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('16:50', 0)),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '225',
        duration: 2100,
        aircraftCode: 'AT7'
      },
      FLT19: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('16:15', 3)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('16:50', 3)),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '225',
        duration: 2100,
        aircraftCode: 'AT7'
      },
      FLT9: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('20:00', 0)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('20:35', 0)),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '633',
        duration: 2100,
        aircraftCode: 'AT7'
      },
      FLT6: {
        departure: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime(todayPlusNdays('14:00', 0)),
          terminal: '5'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('15:55', 0)),
          terminal: '1'
        },
        operatingAirlineCode: 'SK',
        marketingAirlineCode: 'SK',
        marketingFlightNumber: '2728',
        duration: 3300,
        aircraftCode: 'AT7'
      },
      FLT2: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('16:10', 0)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime(todayPlusNdays('16:10', 0)),
          terminal: '2'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '813',
        duration: 3600,
        aircraftCode: '320'
      },
      FLT4: {
        departure: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime(todayPlusNdays('17:20', 0)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('19:15', 0)),
          terminal: '0'
        },
        operatingAirlineCode: 'W2',
        marketingAirlineCode: 'W2',
        marketingFlightNumber: '2104',
        duration: 3300,
        aircraftCode: 'SF3'
      },
      FLT13: {
        departure: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime(todayPlusNdays('15:30', 2)),
          terminal: '5'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('17:25', 2)),
          terminal: '1'
        },
        operatingAirlineCode: 'SK',
        marketingAirlineCode: 'SK',
        marketingFlightNumber: '4234',
        duration: 3300,
        aircraftCode: 'AT7'
      },
      FLT20: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('20:00', 1)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('20:35', 1)),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '633',
        duration: 2100,
        aircraftCode: 'AT7'
      },
      FLT7: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('13:55', 0)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('14:30', 0)),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '223',
        duration: 2100,
        aircraftCode: 'AT7'
      },
      FLT5: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('12:20', 0)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime(todayPlusNdays('12:20', 0)),
          terminal: '2'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '807',
        duration: 3600,
        aircraftCode: '319'
      },
      FLT17: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('16:10', 1)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime(todayPlusNdays('16:10', 1)),
          terminal: '2'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '813',
        duration: 3600,
        aircraftCode: '320'
      },
      FLT22: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('08:10', 4)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('09:55', 4)),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '649',
        duration: 6300,
        aircraftCode: 'AT7',
        stops: [
          {
            locationCode: 'MHQ',
            duration: 1200,
            isChangeOfGauge: false,
            arrivalDateTime: new utils.DateTime(todayPlusNdays('09:05', 4)),
            departureDateTime: new utils.DateTime(todayPlusNdays('09:25', 4)),
            aircraftCode: 'AT7'
          }
        ]
      },
      FLT1: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('08:10', 0)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('09:55', 0)),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '649',
        duration: 6300,
        aircraftCode: 'AT7',
        stops: [
          {
            locationCode: 'MHQ',
            duration: 1200,
            isChangeOfGauge: false,
            arrivalDateTime: new utils.DateTime(todayPlusNdays('09:05', 0)),
            departureDateTime: new utils.DateTime(todayPlusNdays('09:25', 0)),
            aircraftCode: 'AT7'
          }
        ]
      },
      FLT21: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('23:45', 3)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('00:25', 4)),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '229',
        duration: 2400,
        aircraftCode: 'AT7'
      },
      FLT18: {
        departure: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime(todayPlusNdays('17:10', 1)),
          terminal: '5'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('19:05', 1)),
          terminal: '1'
        },
        operatingAirlineCode: 'SK',
        marketingAirlineCode: 'SK',
        marketingFlightNumber: '4236',
        duration: 3300,
        aircraftCode: 'AT7'
      },
      FLT14: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('13:55', 2)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('14:30', 2)),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '223',
        duration: 2100,
        aircraftCode: 'AT7'
      },
      FLT16: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('20:00', 2)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('20:35', 2)),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '633',
        duration: 2100,
        aircraftCode: 'AT7'
      },
      FLT10: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('23:45', 0)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('00:25', 1)),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '229',
        duration: 2400,
        aircraftCode: 'AT7'
      },
      FLT25: {
        departure: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime(todayPlusNdays('17:20', 4)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('19:15', 4)),
          terminal: '0'
        },
        operatingAirlineCode: 'W2',
        marketingAirlineCode: 'W2',
        marketingFlightNumber: '2104',
        duration: 3300,
        aircraftCode: 'SF3'
      },
      FLT12: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('14:05', 2)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime(todayPlusNdays('14:00', 2)),
          terminal: '2'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '809',
        duration: 3300,
        aircraftCode: '32B'
      },
      FLT23: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('16:10', 4)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime(todayPlusNdays('16:10', 4)),
          terminal: '2'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '813',
        duration: 3600,
        aircraftCode: '320'
      },
      FLT24: {
        departure: {
          locationCode: 'ARN',
          dateTime: new utils.DateTime(todayPlusNdays('17:10', 4)),
          terminal: '5'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('19:05', 4)),
          terminal: '1'
        },
        operatingAirlineCode: 'SK',
        marketingAirlineCode: 'SK',
        marketingFlightNumber: '4236',
        duration: 3300,
        aircraftCode: 'AT7'
      },
      FLT15: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('16:15', 2)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('16:50', 2)),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '225',
        duration: 2100,
        aircraftCode: 'AT7'
      },
      FLT11: {
        departure: {
          locationCode: 'HEL',
          dateTime: new utils.DateTime(todayPlusNdays('13:55', 1)),
          terminal: '2'
        },
        arrival: {
          locationCode: 'TKU',
          dateTime: new utils.DateTime(todayPlusNdays('14:30', 1)),
          terminal: '1'
        },
        operatingAirlineCode: 'AY',
        marketingAirlineCode: 'AY',
        marketingFlightNumber: '223',
        duration: 2100,
        aircraftCode: 'AT7'
      }
    },
    aircraft: {
      319: 'AIRBUS INDUSTRIE A319',
      320: 'AIRBUS INDUSTRIE A320-100/200',
      '32B': 'AIRBUS INDUSTRIE A321 SHARKLETS',
      AT7: 'AEROSPATIALE/ALENIA ATR 72',
      SF3: 'SAAB SF340A/340B'
    }
  }
};

export const switchedMultiBoundsDisruptedMock: MockMap = {
  retrieveOrder: [
    {
      mockData: retrieveOrderSwitchedMockDisruptedMultiBounds
    }
  ],
  getOrderEligibilities: [],
  getAlternativeOffers: [
    {
      mockData: getAlternativeOffersMockDisruptedMultiBounds
    }
  ],
  acknowledge: [
    createMockData(acknowledgeSuccess)
  ]
};
